import styled, { css } from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const SelectDropdownWrapper = styled.div(
	() => css`
		width: 100%;
	`,
);
